import { JetView } from 'webix-jet';
import { allpayments } from 'models/allpayments';
import { devConfig } from 'config/config';

/**
 * Represents the view for the bets report.
 * Extends the JetView class from webix-jet.
 */
export default class recordTableBetsReportView extends JetView {
    /**
     * Configures the datatable view for the bets report.
     * @returns {Object} The configuration object for the datatable.
     */
    config() {
        const _ = this.app.getService('locale')._;
        const dateFormat = webix.Date.dateToStr(this.app.config.dateFormat);
        const filterDetails = webix.ui({
            view: 'window',
            move: true,
            id: 'filterDetails2',
            fullscreen: true,
            head: {
                view: 'toolbar',
                cols: [
                    {
                        view: 'label',
                        label: _('Detalles del Ticket'),
                        align: 'center',
                    },
                    {
                        view: 'icon',
                        icon: 'wxi-close',
                        click: function () {
                            this.getTopParentView().hide();
                        },
                    },
                ],
            },
            modal: true,
            position: 'center',
            body: {
                view: 'datatable',
                id: 'dtDetails2',
                css: 'webix_header_border webix_data_border webix_footer_border',
                select: true,
                columns: [
                    {
                        id: 'Id',
                        header: _('Ticket Det Id'),
                        width: 100,
                        sort: 'int',
                    },
                    {
                        id: 'TicketId',
                        header: _('Ticket ID'),
                        width: 100,
                        sort: 'int',
                    },
                    {
                        id: 'Description',
                        header: _('Descripción'),
                        width: 250,
                        sort: 'int',
                    },
                    {
                        id: 'Market',
                        header: _('Market'),
                        width: 100,
                        sort: 'int',
                    },
                    { id: 'Option', header: 'Option', width: 200, sort: 'int' },
                    {
                        id: 'Odds',
                        header: _('Odds'),
                        width: 100,
                        format: webix.i18n.numberFormat,
                        sort: 'int',
                    },
                ],
            },
        });
        return {
            view: 'datatable',
            css: 'webix_header_border webix_data_border webix_footer_border',
            select: true,
            columns: [
                {
                    id: 'Id',
                    header: _('Ticket Det Id'),
                    width: 100,
                    sort: 'int',
                },
                {
                    id: 'TicketId',
                    header: _('Ticket ID'),
                    width: 100,
                    sort: 'int',
                },
                {
                    id: 'Description',
                    header: _('Descripción'),
                    width: 250,
                    sort: 'int',
                },
                { id: 'Market', header: _('Market'), width: 100, sort: 'int' },
                { id: 'Option', header: 'Option', width: 200, sort: 'int' },
                {
                    id: 'Odds',
                    header: _('Odds'),
                    width: 100,
                    format: webix.i18n.numberFormat,
                    sort: 'int',
                },
            ],
            loadahead: 0,
            datafetch: devConfig.getDefaultDataFetch(),
            pager: 'pagerA',
        };
    }

    /**
     * Initializes the datatable and sets up event listeners for user ID changes.
     * @param {Object} grid - The datatable instance.
     */
    init(grid) {
        var url = devConfig.geturlApi() + 'null/Report/GetBetHistoryDetail';
        this.on(this.app, 'user:id', (idUser) => {
            grid.clearAll();
            grid.load(url + '?id=' + idUser);
            $$('dtDetails2').clearAll();
            $$('dtDetails2').load(url + '?id=' + idUser);
        });
    }
}

// FILE DOCUMENTED
